import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useAppTranslate } from "src/hooks/useAppTranslate";

interface UploadCompleteDialogProps {
  open: boolean;
  onClose: () => void;
  onUploadMore: () => void;
  onViewCart: () => void;
}

const UploadCompleteDialog: React.FC<UploadCompleteDialogProps> = ({
  open,
  onClose,
  onUploadMore,
  onViewCart,
}) => {
  const translate = useAppTranslate();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{translate("order.uploadComplete")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {translate("order.uploadMoreOrContinue")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onUploadMore} variant="outlined">
          {translate("order.uploadMore")}
        </Button>
        <Button onClick={onViewCart} variant="contained" color="primary">
          {translate("order.viewCart")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadCompleteDialog;
